export default {
	project_name: 'Edu Pine',
	error_logging_in_check_that_the_data_is_correct_if_you_still_can_t_get_it_contact_your_manage:
		'Erro ao efetuar login. Verifique se os dados estão corretos. Se mesmo assim não conseguir, entre em contato com o seu gestor.',
	user: 'E-mail',
}
